import storage from "@/services/storage";
import currency, { Options } from "currency.js";
export function makeid(length) {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

export function isValidUrl(url?: string) {
  if (!url) {
    return false;
  }
  const regex = new RegExp(
    /^(?:(?:https?):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/
  );
  return regex.test(url || "");
}

export function checkStartOfUrl(url?: string) {
  if (!url) {
    return false;
  }
  const regex = new RegExp("^(https://|http://|www.)");
  return regex.test(url);
}
export const diffInDays = (
  startdate: string | number | Date = new Date(),
  endDate: string | number | Date = new Date()
) => {
  const date1: any = new Date(startdate);
  const date2: any = new Date(endDate);
  const diffTime = Math.abs(date2 - date1);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return diffDays;
};

export const formatCurrency = (value: string | number, options?: Options) => {
  return currency(value || 0, options).format();
};
type IWeekStartFrom = "mon" | "tue" | "wed" | "thu" | "fri" | "sat" | "sun";
const getWeekMap = (startFrom: IWeekStartFrom = "mon") => {
  switch (startFrom) {
    case "sun":
      return [0, 1, 2, 3, 4, 5, 6];
    case "sat":
      return [1, 2, 3, 4, 5, 6, 0];
    case "fri":
      return [2, 3, 4, 5, 6, 0, 1];
    case "thu":
      return [3, 4, 5, 6, 0, 1, 2];
    case "wed":
      return [4, 5, 6, 0, 1, 2, 3];
    case "tue":
      return [5, 6, 0, 1, 2, 3, 4];
    case "mon":
      return [6, 0, 1, 2, 3, 4, 5];
    default:
      return [0, 1, 2, 3, 4, 5, 6];
  }
};

export function getStartAndEndOfWeek(
  date: Date | string | number,
  startFrom: IWeekStartFrom = "mon"
) {
  const weekMap = getWeekMap(startFrom);
  var now = new Date(date);
  now.setHours(0, 0, 0, 0);
  var monday = new Date(now);
  monday.setDate(monday.getDate() - weekMap[monday.getDay()]);
  var sunday = new Date(now);
  sunday.setDate(sunday.getDate() - weekMap[sunday.getDay()] + 6);
  sunday.setHours(23, 59, 59, 999);
  return [monday, sunday];
}

export const getPredefindMessageKey = (id) => {
  return `predefned_message_${id}`;
};
export const getFile = async (key: string): Promise<string> => {
  return await storage
    .get(key)
    .then((result: any) => {
      return result;
    })
    .catch(() => "");
};
